<script setup lang="ts">
import InputNumber from 'primevue/inputnumber'
import InputText from 'primevue/inputtext'
import type { MergeUsage } from '@/types/batch-types'
import { useFieldArray } from 'vee-validate'
import { onMounted, watch } from 'vue'

const props = defineProps<{
  modelValue?: MergeUsage[],
  class?: string
  formPath: string
}>()

const { fields, replace } = useFieldArray(props.formPath);

// Ensure fields are populated with modelValue on mount or when modelValue changes
onMounted(() => {
  if (props.modelValue && props.modelValue.length > 0) {
    replace(props.modelValue);
  }
});

// Watch for changes in modelValue and update the fields accordingly
watch(() => props.modelValue, (newValue) => {
  if (newValue && newValue.length > 0) {
    replace(newValue);
  }
});


</script>

<template>
  <div v-for="(merge, index) in fields" :key="index" :class="props.class">
    <div class="grid grid-cols-3 gap-10">
      <div class="flex flex-col gap-2">
        <label for="mergeNumber" class="text-sm">Selected Merge Number:</label>
        <InputText
          id="mergeNumber"
          v-model="(merge.value as MergeUsage).mergeNumber"
          placeholder="Enter new batch number here"
          disabled
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="kiloUsed" class="text-sm">Kilo Used:</label>
        <InputNumber
          id="kiloUsed"
          v-model="(merge.value as MergeUsage).kiloUsed"
          placeholder="Enter kilo of yarn used"
        />
      </div>

      <div class="flex flex-col gap-2">
        <label for="kiloWasted" class="text-sm">Kilo Wasted:</label>
        <InputNumber
          id="kiloWasted"
          v-model="(merge.value as MergeUsage).kiloWasted"
          placeholder="Enter kilo of yarn wasted"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>